import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { DEFAULT_DIAL_CODE, dialCodesByCountry, languageToCountry } from '../constants/phoneDialCodes'
import { SupportedDialCodeCountry } from '../types/phoneDialCode'

const isSupportedDialCodeCountry = (countryId: string): countryId is SupportedDialCodeCountry =>
  countryId in dialCodesByCountry

const getDialCodeByOrganizationCountry = (
  organizationCountryId: Organization['countryId'] | undefined,
): string | undefined =>
  organizationCountryId && isSupportedDialCodeCountry(organizationCountryId)
    ? dialCodesByCountry[organizationCountryId]
    : undefined

const getDialCodeByBrowserLanguage = (browserLanguage: string | undefined): string | undefined => {
  const languagePrefix = browserLanguage?.toLowerCase().split('-')[0]
  const country = languagePrefix && languageToCountry[languagePrefix]

  return country ? dialCodesByCountry[country] : undefined
}

export const getPhoneDialCodePlaceholder = (
  organizationCountryId: Organization['countryId'] | undefined,
  browserLanguage: string | undefined,
): string =>
  getDialCodeByOrganizationCountry(organizationCountryId) ??
  getDialCodeByBrowserLanguage(browserLanguage) ??
  DEFAULT_DIAL_CODE
